module.exports = __webpack_public_path__ + "static/media/2.jpg.d7b5003a.webp";